import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

/**
 * 0010. ユーザ登録（Email検証依頼）
 * [POST] /email_registrations/new
 */
type CreateEmailRegistrationParams = {
  email: string;
  password: string;
  password_confirmation: string;
  invitation: string | null;
};
type CreateEmailRegistrationResponse = {
  email_registration_token: string;
};
export const createEmailRegistration = (
  params: CreateEmailRegistrationParams
): Promise<CreateEmailRegistrationResponse> => {
  return axios.post(`/api/email_registrations`, params);
};

export const useCreateEmailRegistration = () => {
  return useMutation({
    mutationFn: createEmailRegistration,
  });
};
